import { useQuery } from '@tanstack/react-query';
import { filesApi } from '@/services/files.api';
import { hasImageThumbnail } from './file-type';

function FileGlyph() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M7 3h7l5 5v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z" />
      <path d="M14 3v5h5" />
    </svg>
  );
}

/**
 * A small square before each file name — the real picture for an image
 * (fetched from the same signed URL `Download`/`Preview` use, and shared
 * with `PreviewDialog` under the same query key), a generic document glyph
 * for everything else. Only image rows fetch anything; a PDF or a Word
 * file has no cheap way to render a real thumbnail, so it doesn't pretend
 * to.
 */
export function FileThumbnail({ fileId, mimeType }: { fileId: string; mimeType: string }) {
  const isImage = hasImageThumbnail(mimeType);

  const download = useQuery({
    queryKey: ['cloud', 'preview-url', fileId],
    queryFn: () => filesApi.getDownloadUrl(fileId),
    enabled: isImage,
    staleTime: 5 * 60 * 1000,
  });

  return (
    <span className="file-thumb">
      {isImage && download.data ? <img src={download.data.url} alt="" /> : <FileGlyph />}
    </span>
  );
}
